<template>
  <div class="line-chart">
    <div class="line-chart-graph">
      <line-chart
        ref="chart"
        :chartData="lineChartData"
        :options="lineChartOptions"
        :styles="{'display':'flex', 'justify-content':'center', 'height': '300px'}">
      </line-chart>
      <div class="line-chart-data is-finance" style="margin-left:8%;">
        <div class="line-chart-data__item" v-for="(data, key) in values" :key="key"><Currency :value="data"/>{{unit}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import LineChart from '@/components/parts/chart/LineChart.vue';
import Currency from '@/components/parts/human_capital/parts/Currency.vue';

export default {
  components: {
    LineChart,
    Currency,
  },
  props: {
    corpId: {},
    startYear: {},
    unit:{},
  },
  data() {
    return {
      lineChartData: {
        labels: [],
        datasets: [],
      },
      lineChartOptions: {},
      values: [],
    }
  },
  created: async function () {
    await this.initChart();
  },
  methods: {
    async initChart(){
      this.lineChartData.labels = ["----年度", "----年度", "----年度", "----年度", "----年度"];
      this.lineChartData.datasets = {};
    },
    /**
     * 年度ラベル取得　最新年度から５年分
     */
    async getYearLabels(corpId, year) {
      let res = await this.$axios.post('/ld/api/hr/getYearLabels', {corpId:corpId, year: year });
      if (res) {
        this.lineChartData.labels = res.data.labels;
      }
    },
    /**
     * 労災発生件数取得
     */
    async getHumanCapitalLineChartData(corpId, year) {
      if (corpId) {
        let res = await this.$axios.post('/ld/api/hr/getHumanCapitalLineChartData', {
          hrType: 8, // 8:労災発生件数
          corpId:corpId, 
          year: year
        });
        if (res) {
          this.values = res.data.dataset1;
          let unit = '件';
          let goalValue = (res.data.dataset2[0]);
          let tmp = res.data.dataset1.slice();
          tmp.push(goalValue);

          let cleanedData = tmp.filter(x => x !== null);
          let min1401 = 0;
          let max1401 = Math.round(Math.max.apply(null, cleanedData) + 1);
          let stepsize1401= Math.round((max1401 - min1401) / 5);

          let datasets = [];
          let dataset = {
            data: res.data.dataset1, // データ配列（実績）
            label: '実績', // データ名称
            borderWidth: 4, // ラインの太さ
            fill: false, // ライン以下の領域を塗りつぶすかどうか
            lineTension	: 0, // 滑らかな曲線設定　0:直線
            borderColor: "#0072c4", // ライン色
            pointBackgroundColor: function(context) { // 指標点の背景色
                let index = context.dataIndex;
                let count = context.dataset.data.length - 1;
                return index === count ? '#0072c4' : '#0072c4';
            },
            pointRadius: function(context) {　// 指標点の形状設定
                let index = context.dataIndex;
                let count = context.dataset.data.length - 1;
                return index === count ? 8 : 4;
            }
          };
          datasets.push(dataset);

          let dataset2 = {
            data: res.data.dataset2, // データ配列（実績）
            label: "目標", // データ名称
            borderWidth: 4, // ラインの太さ
            fill: false, //ライン以下の領域を塗りつぶすかどうか
            lineTension	: 0, //滑らかな曲線設定 0:直線
            borderColor: "#ff6384", // ライン色
            pointRadius: 0.3, // ポイント非表示
            pointBackgroundColor: function(context) { // 指標点の背景色
                let index = context.dataIndex;
                let count = context.dataset.data.length - 1;
                return index === count ? '#ff6384' : '#ff6384';
            },
          };
          datasets.push(dataset2);
          this.lineChartData.datasets = datasets;

          let options = {
            legend: {
              position: 'left',
              display: false,
            },
            responsive: true,
            maintainAspectRatio: false,
            hover: {
              mode: 'index',
              intersec: false
            },
            scales: {
              // X-Axis
              xAxes: [{
                display: true,
                gridLines: {
                  display:true
                },
              }],
              // Y-Axis
              yAxes: [{
                display: true,
                position: 'left',
                ticks: {
                  min:min1401,
                  max:max1401,
                  stepSize:stepsize1401,
                  maxTicksLimit: 10,
                  callback: (value) => `${value}` + unit,
                },
              }]
            }, // scales end
            tooltips : {
              callbacks: {
                title(tooltipItem, data) {
                  const index = tooltipItem[0].datasetIndex;
                  if(index == 1) return '';
                  const idx = tooltipItem[0].index;
                  const title = data.labels[idx];
                  return title;
                },
                label(tooltipItem, data) {
                  const idx = tooltipItem.datasetIndex;
                  const label = data.datasets[idx].label;
                  return [label + ':' + tooltipItem.value + unit];
                }
              }
            }, // tooltips end
          };
          this.lineChartOptions = options;
        }
      }
    },
    /**
     * LineChartの再描画処理
     */
    async recreateChart(corpId, year) {
      await this.getYearLabels(corpId, year);
      await this.getHumanCapitalLineChartData(corpId, year);
      this.$refs.chart.reRenderChart(this.lineChartData, this.lineChartOptions)
    },
  },
}
</script>

<style scoped>
.chart-area {
  border: 2px solid rgba(220, 220, 220, 0.5);
  border-radius: 10px;
  padding: 10px;
  background-color: rgba(248, 248, 255, 0.5);
}
</style>